
const UploadApproval = ({ status, approveReject }: { status: string, approveReject: Function }) => {
    let primaryButtonLabel = '';
    let secondaryButtonLabel = '';

    if (status === 'pending') {
        primaryButtonLabel = 'Approve';
        secondaryButtonLabel = 'Reject';
    } else if (status === 'approve') {
        primaryButtonLabel = 'Yes';
        secondaryButtonLabel = 'No';
    }

    return (

        <div>
            <div className="modal fade" aria-hidden="true" id="upload-Approval">
                <div className="modal-dialog modal-dialog-centered" >
                    <div className="modal-content bg-white">
                        <div className="modal-body pt-4 pb-3 text-center main-msg">
                            <p className='mb-0'>{status === "pending"
                                ? "Do you want to Approve or Reject this?" : "Do you want to Reject this?"
                            }</p>
                        </div>
                        <div className="modal-footer justify-content-center border-top-0 pb-4">
                            <button type="button" className="grey-outline-btn mr-3" data-bs-dismiss="modal" onClick={(e) => approveReject(e, secondaryButtonLabel)}>{secondaryButtonLabel}</button>
                            <button type="button" className="outline-icon-btn" data-bs-dismiss="modal" onClick={(e) => approveReject(e, primaryButtonLabel)}>{primaryButtonLabel}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UploadApproval